<template>
  <div v-if="lecture" class="flex flex-col">
    <TeacherTitleSlug
      v-if="false"
      :title="lecture.title"
      :highlight-title="highlight.title"
      :highlight-paragraph="highlightParagraph"
      :link-for-back="`/teacher/${$route.params.parent}/${$route.params.category}?content=${lecture.model_type}${groupList}`"
    />
    <article class="flex flex-col">
      <div class="mb-[120px] flex gap-[20px]">
        <div class="flex w-full flex-col">
          <div class="grid gap-5 lg:grid-cols-3 xl:grid-cols-4">
            <div class="xl:max-w-full size-full lg:col-span-2 xl:col-span-3">
              <div
                class="aspect-wrap relative w-full overflow-hidden rounded-2xl"
                style="padding-bottom: calc(9 / 16 * 100%)"
              >
                <img
                  v-lazy-load
                  :src="lecture.image?.src"
                  alt=""
                  class="size-full object-cover"
                />
                <div
                  class="transition-effect absolute inset-0"
                  :class="{
                    'bg-[#000]/50': !currentIsPlaying,
                  }"
                >
                  <TeacherAudioPlayButton
                    :data="lecture"
                    class="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-1/2"
                  />
                </div>
              </div>
              <ClientOnly>
                <div class="mt-2">
                  <a :href="downloadLink" download class="ml-auto block w-fit">
                    <button
                      class="flex items-center justify-center rounded-xl bg-[#F5F5F5] px-6 py-4 font-roboto text-[14px] font-medium uppercase leading-[17px]"
                    >
                      <SvgIcon name="download" class="mr-2 size-5" />
                      Скачать
                    </button>
                  </a>
                </div>
              </ClientOnly>
            </div>
            <div
              v-if="!isLessThanHorizontalPad"
              class="relative col-span-1 size-full max-w-[367px] overflow-y-hidden rounded-[12px] shadow-drop-2 lg:row-span-2 lg:max-h-[694px] xl:row-span-1"
            >
              <CommonBlocksVideoPlayList
                :data="sortedCollection"
                :count="sortedCollection?.length"
                :rubrics-title="highlight?.title"
                :category-title="categoryTitle"
                :active="activeIndex"
                is-audio
                class="inset-0 h-full xl:absolute"
                @change-active="handleActiveVideo($event)"
              />
            </div>
            <div class="lg:col-span-2 xl:col-span-4">
              <h1
                class="mb-2 font-roboto text-[20px] font-medium leading-[26px] lg:mb-[28px]"
                v-text="lecture?.title"
              />
              <div
                v-if="isLessThanHorizontalPad"
                class="mb-3 font-roboto text-[14px] font-semibold leading-[17px] text-[#808080]"
              >
                {{ activeIndex + 1 }} аудио из {{ sortedCollection.length }}
              </div>
              <h2
                class="text-[16px] font-medium leading-[24px]"
                v-html="lecture?.description"
              />
              <!--              <div-->
              <!--                ref="wrapDataTextContent"-->
              <!--                class="overflow-hidden"-->
              <!--                :class="{-->
              <!--                  'h-[84px]': isCollapse && isHiddenText,-->
              <!--                }"-->
              <!--              >-->
              <!--                <div-->
              <!--                  v-if="data?.title"-->
              <!--                  ref="dataTextContent"-->
              <!--                  class="-->
              <!--                    text-primary-1-->
              <!--                    leading-6-->
              <!--                    md:text-primary-2 md:leading-[21px]-->
              <!--                    xl:text-primary-1 xl:leading-6-->
              <!--                    page-body-->
              <!--                    lg:mb-[65px]-->
              <!--                  "-->
              <!--                  v-html="data.body"-->
              <!--                ></div>-->
              <!--              </div>-->
              <!--              <div-->
              <!--                v-if="isHiddenText"-->
              <!--                class="-->
              <!--                  text-[#A10009] text-[16px]-->
              <!--                  leading-[24px]-->
              <!--                  font-medium-->
              <!--                  mt-2-->
              <!--                  cursor-pointer-->
              <!--                  highlight-->
              <!--                "-->
              <!--                @click="isCollapse = !isCollapse"-->
              <!--              >-->
              <!--                {{ isCollapse ? 'Развернуть' : 'Свернуть' }}-->
              <!--              </div>-->
              <!--              <the-button-new-->
              <!--                v-if="!isLessThanHorizontalPad"-->
              <!--                text="ВСЕ ПЛЕЙЛИСТЫ"-->
              <!--                type="default"-->
              <!--                icon="chevron-left"-->
              <!--                icon-position="left"-->
              <!--                class="mt-12 mb-8 w-full sm:w-fit justify-center max-h-[64px]"-->
              <!--                @click.native="$router.go(-1)"-->
              <!--              />-->
            </div>
            <template v-if="isLessThanHorizontalPad">
              <CommonBlocksVideoPlayList
                :data="sortedCollection"
                :count="sortedCollection?.length"
                :rubrics-title="highlight?.title"
                :category-title="categoryTitle"
                :active="activeIndex"
                title-disabled
                is-audio
                @change-active="handleActiveVideo($event)"
              />
              <!--              <the-button-new-->
              <!--                text="ВСЕ ПЛЕЙЛИСТЫ"-->
              <!--                type="default"-->
              <!--                icon="chevron-left"-->
              <!--                icon-position="left"-->
              <!--                class="mt-12 mb-8 w-full sm:w-fit justify-center max-h-[64px]"-->
              <!--                @click.native="$router.go(-1)"-->
              <!--              />-->
            </template>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup>
import api from '@/services/api/api';

definePageMeta({
  layout: 'marginless',
});

const props = defineProps({
  highlight: {
    type: Object,
    default: () => ({}),
  },
  data: {
    type: Array,
    default: () => [],
  },
  category: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:collection']);

const route = useRoute();
const router = useRouter();
const audioStore = useAudioStore();
const crumbsStore = useBreadcrumbsStore();
const { secondsToISO } = helperSeo();
const { isLessThanHorizontalPad, handleResize } = useBreakpoint();
const slug = route?.params?.slug;
const { audioLecture } = useAudioLecturesBySlug(slug);
useErrorHandler(() => audioLecture.failureReason.value?.status);

/**computed */
const lecture = computed(() => audioLecture?.data?.value);

const currentIsPlaying = computed(() => {
  return audioStore.getData?.id === lecture.value?.id;
});

const groupList = computed(() => {
  if (!route?.query?.group) return '';
  return `&group=${route.query.group}`;
});

const highlightParagraph = computed(() => {
  let highlightIdx;
  props.category.chapters.find((item) =>
    item.highlights.find((highlight) => {
      if (highlight.id !== props.highlight?.id) return '';
      highlightIdx = highlight.number;
      return highlight;
    }),
  );
  return highlightIdx ? `§ ${highlightIdx}.` : '';
});

const sortedCollection = computed(() => {
  return props.data; /*?.filter((item) => {
    return item.model_type === 'audiolecture';
  });*/
});

const activeIndex = computed(() => {
  return sortedCollection.value?.findIndex(
    (item) => item.slug === lecture.value?.slug,
  );
});

const categoryTitle = computed(() => {
  return `${props.category?.school_class?.title} класс (${props.category?.title})`;
});

const downloadLink = computed(() => {
  return (
    document.location.protocol +
    '//' +
    document.location.host +
    lecture.value.path
  );
});

/**mounted */
onMounted(async () => {
  if (props.data?.length === 0) {
    try {
      const slug = route.params.category;
      const { data: collectionSlug } =
        await api.collections.getCollectionItemsBySlug(slug, 'audiomaterial');
      emit('update:collection', collectionSlug?.data ?? []);
    } catch (e) {
      console.log(e);
    }
  }
});

/**methods */
const handleActiveVideo = async (slug) => {
  if (route.params?.slug === slug) return;

  await router.replace({
    query: route.query,
    params: {
      ...route.params,
      slug,
    },
  });
  handleResize();
};

/**watch */
watch(
  lecture,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'slug',
      value: {
        title: lecture.value?.title,
        slug: lecture.value?.slug,
      },
    });
  },
  { immediate: true },
);

onBeforeRouteLeave(() => {
  crumbsStore.setCrumbs({ key: 'slug', value: null });
});

useHead(() => ({
  title: `${
    lecture.value?.title ? `${lecture.value.title} |` : ''
  } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
  meta: [
    {
      hid: 'og:type',
      property: 'og:type',
      content: 'music.song',
    },
    { property: 'og:title', content: lecture.value?.title },
    {
      property: 'og:url',
      content: `${useHostApp()}/listen/lectures/${slug}`,
    },
    {
      property: 'og:image',
      content: `${useHostApp()}${lecture.value?.image?.src}`,
    },
    {
      name: 'ya:ovs:upload_date',
      content: lecture.value?.published_at,
    },
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      property: 'og:description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href:
        `${useHostApp()}/listen/lectures/${lecture.value?.slug}` ||
        `${useHostApp()}${route.path}`,
    },
  ],
}));

useSchemaOrg(() =>
  defineArticle({
    '@type': 'AudioObject',
    uploadDate: new Date(lecture.value?.published_at),
    duration: secondsToISO(lecture.value?.metadata?.duration),
    bitrate: `${(lecture.value?.metadata?.bitrate / 1000)?.toFixed(0)} kbps`,
    contentUrl: `${useHostApp()}${lecture.value?.path}`,
    thumbnailUrl: `${useHostApp()}${lecture.value?.image?.src}`,
    author: lecture.value?.authors?.map((author) => ({
      name: author.fullname,
      url: `${useHostApp()}/authors/${author.slug}`,
      sameAs: `${useHostApp()}/authors/${author.slug}`,
      description: author.description,
      ...(author?.image.is_blank && {
        image: {
          '@type': 'ImageObject',
          url: `${useHostApp()}${author.image.preview}`,
          width: 400,
          height: 400,
          caption: author.image.alt || '',
        },
      }),
    })),
  }),
);
</script>

<style scoped>
.highlight {
  -webkit-tap-highlight-color: #0000;
}
</style>
